// extracted by mini-css-extract-plugin
export default {"options":"JoinStudioPage_options__ftley","option":"JoinStudioPage_option__Mfw0v"};